export const SET_REDIRECTING_PATH = "SET_REDIRECTING_PATH"